import Humanize from 'humanize-plus';

import './image-styles.css';

export const DocPreview = ({ image }) => {
    return (
        <div className="gallery">
            <div style={{ cursor: "pointer" }} className="image">
                <div className="image-inner rounded border">

                    <img onClick={() => window.open(image.pathIncludingSasToken, "_blank")} src={image.thumbPathIncludingSasToken || image.pathIncludingSasToken} alt={image.description} title={image.description} style={{ width: "100%", height: "100%", borderRadius: "10px" }} />

                    <div className="image-caption">
                        <i title='logo' className={`fa fa-lg ${image.documentFormat.icon}`}></i>&nbsp;&nbsp;{image.documentFormat.description}
                        <div>{Humanize.fileSize(image?.size || 0)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};